import React from 'react';
import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth.js';
// css 
import './ComponentsCss/UserInfo.css';
// imgs 
import signImg from "../imgs/sign.png";
import LogoImg from "../imgs/logo-hori.png"


import toast, { Toaster } from 'react-hot-toast';
const errNotify = (Text) => toast.error(Text);
const Notify = (Text) => toast.success(Text)

const POAModal = ({ ModalOpenCallBack, ModalDataCallBack }) => {


    const [UserData, SetUserData] = useState();
    const [UserAddress, SetUserAddress] = useState("");
    const axiosPrivate = useAxiosPrivate();
    useEffect(() => {
        axiosGetUserInfo();
    }, []);
    const { auth, setAuth } = useAuth();
    const customStylesColorPicker = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            height: '80%'
        },
    };

    const [ModalIsOpen, setModalIsOpen] = useState(true);
    function onCloseModal() {
        console.log("Close modal");
        setModalIsOpen(false);
        ModalOpenCallBack(false);
        ModalDataCallBack("SOME BLOB DATA ");
    }
    function POACheck() {
        if (UserAddress == "") {
            errNotify("주소를 입력해주세요.");

        } else if (UserAddress.length > 0) {
            axiosPostPOA();
        }
    }
    function getDate() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        return `${year}년 ${month}월 ${date}일 `;
    }
    const axiosGetUserInfo = async () => {
        const controller = new AbortController();
        try {
            var DataJson = "";
            DataJson = JSON.stringify({
                userId: auth?.UserId,

            }, null, 2);

            console.log("axiosGetUserInfo  : " + DataJson);
            var finalIP = "";

            finalIP = "https://https://stepupkorea.kr/api/userInfo";

            const response = await axiosPrivate.post(finalIP,
                DataJson,
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            if (response) {

                console.log(" axiosGetUserInfon success::: ", JSON.stringify(response?.data));
                SetUserData(response?.data);
            }



        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 404) {
                console.log('--No user ID');
            } else if (err.response?.status === 400) {
                console.log('Wrong pass ');

            } else if (err.response?.status === 403) {
                console.log('Access token expire ');
                errNotify("자동 로그아웃됬습니다. 다시 로그인 해주세요.");
                setAuth();
            } else {
                console.log('ERR');
            }

        }
    }

    const axiosPostPOA = async () => {
        console.log(" axiosPostPOA user ");
        try {
            // const { userId, userPw, confUserPw, userName, 
            //        userEmail, userMobile, userRole } = req.body;
            var DataJson = "";
            DataJson = JSON.stringify({
                userId: auth?.UserId,
                userName: UserData?.userName,
                userAddress: UserAddress,
                userMobile: UserData?.userMobile,
                userPOA: 1
            }, null, 2);

            console.log("AXIOS Registering user POA : " + DataJson);
            var finalIP = "";
            // 	"/emergency/rssi/module-status-set/<ip>"
            finalIP = "https://stepupkorea.kr/api/userPOA";
            //console.log(" axiosPostModuleStatus" + finalIP);
            const response = await axiosPrivate.post(finalIP,
                DataJson,
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true,

                }
            );
            if (response) {
                console.log(" POA success !");
                Notify("작성 성공!");
                onCloseModal();

            }
        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Username and password are required.');
                //errNotify("ID 와 비밀번호를 입력 해주세요.");
            } else if (err.response?.status === 401) {
                console.log('-- Wrong conf password ');
                //errNotify("비밀번호 확인에 같은 비밀번호를 입력해주세요. ");
            }
            else if (err.response?.status === 402) {
                console.log('-- Username already exists ');
                errNotify("이미 위임장을 작성하셨습니다. 감사합니다.");
                onCloseModal();
            } else {
                console.log('ERR');
            }

        }
    }
    return (
        <div>
            <Modal
                isOpen={ModalIsOpen}
                onRequestClose={onCloseModal}
                style={customStylesColorPicker}
                contentLabel="POA Modal"
                ariaHideApp={false}>

                <>
                    <div className="input-group" >
                        <button className="go-back " onClick={() => onCloseModal()}>
                            뒤로가기
                        </button>
                    </div>

                    <div className="FlexCol">
                        <div className="Title">
                            대리인위임장
                        </div>
                        <div className="SubTitle" >
                            위임인 인적사항
                        </div>
                        <div>
                            <div className="FlexRow">
                                <div className="ColTitle">성명</div>
                                <div className="ColText"> {UserData?.userName} </div>
                            </div>
                            <div className="FlexRow">
                                <div className="ColTitle">상세주소</div>
                                <input type='text' className="ColText" value={UserAddress} onInput={e => SetUserAddress(e.target.value)} />
                            </div>
                            <div className="FlexRow">
                                <div className="ColTitle">전화번호</div>
                                <div className="ColText"> {UserData?.userMobile} </div>
                            </div>
                        </div>

                        <div className="SubTitle" >
                            수임인 인적사항
                        </div>
                        <div>
                            <div className="FlexRow">
                                <div className="ColTitle">성명</div>
                                <div className="ColText"> 도태우</div>
                            </div>
                            <div className="FlexRow">
                                <div className="ColTitle">상세주소</div>
                                <div className="ColText"> 서울특별시 영등포구 국회대로 750 금산빌딩 712호 </div>
                            </div>
                            <div className="FlexRow">
                                <div className="ColTitle">전화번호</div>
                                <div className="ColText"> 010-5663-6907 </div>
                            </div>
                        </div>

                        <div className="SubTitle" >
                            위임내용
                        </div>
                        <div>
                            <div className="LeftTextBox">
                                이성윤 의원을 직권남용죄로 고발합니다. 도태우 변호사에게 위임합니다.
                            </div>
                        </div>

                        <div className="FlexCol">
                            <div className="CenterTextBox" > 본인은 위 수임인(도태우 변호사)을(를) 대리인으로 정하고 위의 내용에 대하여 대리인에게 위임합니다.</div>
                            <div className="CenterTextBox">
                                {getDate()}
                            </div>
                            <div className="CenterTextBox"> 위임자: {UserData?.userName} [성명] </div>

                        </div>

                        <hr
                            style={{
                                color: "black",
                                width: "100%",
                                height: "1px"
                            }}
                        />

                        <div className="FlexCol">
                            <div className="CenterTextBox" > 본인은 업무를 진행하는 과정 취득한 정보를 본 목적 외에 다른 용도로 사용하지 않습니다.</div>
                            <div className="CenterTextBox">
                                {getDate()}
                            </div>
                            <div className='FlexRow justify-center'>
                                <div className="CenterTextBox bold align-items-center" style={{ width: "auto" }}> 수임자 성명 도태우 </div>
                                <img src={signImg} className='SignImg' />
                            </div>
                            <div className='FlexRow justify-center'>
                                <img src={LogoImg} className='logoImg' />
                            </div>


                        </div>
                    </div>
                    <br />
                    <button className="mobile-button " onClick={() => POACheck()} >

                        대리인 위임장 작성하기
                    </button>

                </>
            </Modal>

        </div>
    )
}

export default POAModal